var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 41.6666C222.641 41.6666 195.55 47.0553 170.274 57.5251C144.998 67.9948 122.032 83.3405 102.686 102.686C63.616 141.756 41.6667 194.747 41.6667 250C41.6667 305.253 63.616 358.244 102.686 397.314C122.032 416.659 144.998 432.005 170.274 442.475C195.55 452.945 222.641 458.333 250 458.333C305.253 458.333 358.244 436.384 397.314 397.314C436.384 358.244 458.333 305.253 458.333 250C458.333 222.641 452.945 195.55 442.475 170.274C432.005 144.998 416.659 122.032 397.314 102.686C377.968 83.3405 355.002 67.9948 329.726 57.5251C304.45 47.0553 277.359 41.6666 250 41.6666M145.833 197.917C145.833 181.25 160.417 166.667 177.083 166.667C193.75 166.667 208.333 181.25 208.333 197.917C208.333 214.583 193.75 229.167 177.083 229.167C160.417 229.167 145.833 214.583 145.833 197.917ZM307.708 358.958C298.333 343.75 276.042 333.333 250 333.333C223.958 333.333 201.667 343.75 192.292 358.958L162.708 329.375C181.458 306.667 213.542 291.667 250 291.667C286.458 291.667 318.542 306.667 337.292 329.375L307.708 358.958M322.917 229.167C306.25 229.167 291.667 214.583 291.667 197.917C291.667 181.25 306.25 166.667 322.917 166.667C339.583 166.667 354.167 181.25 354.167 197.917C354.167 214.583 339.583 229.167 322.917 229.167Z",
    fill: "#666666"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sad.7dde07ba3088074a4ddc45e767c21de0.svg";